/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from "react";
import Search from "./Search";
//https://identitatcorporativa.gencat.cat/web/.content/Documentacio/descarregues/dpt/BN/Vice_PDigitals/gencat_cat_bn.png
function Nav(props){
    const{panTo} = props;
    
    return(
        <div className="nav">
            <div className="navh1">
                <img className="h1image" src="/logo2.png" alt="h1image"></img>
                <img className="h1image" src="/logo2.png" alt="Logo del Departament de Salut de la Generalitat de Catalunya"></img>
                <input type="checkbox" id="nav-check"/>
                <div className="nav-btn">
                    <label htmlFor="nav-check">
                        <span></span>
                        <span></span>
                        <span></span>
                    </label>
                </div>
                <div className="nav-links">
                    <div className="search-nav">
                        <Search panTo = {panTo} />
                    </div>
                </div>
            </div>
            <div className="navh2">
                <div className="nav-title">
                    Registre de Desfibril·ladors Automàtics (RDA)
                </div>
            </div>
        </div> 
        
    );
}

export default Nav;